import { useEffect, useState, useRef } from "react";
import { FaEye } from "react-icons/fa";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Link } from "react-router-dom";
import "./calendar.css";
import ViewTrainingModal from "./ViewTrainingModal";
// import DeleteTrainingModal from "./DeleteTrainingModal";
import ParticipantsModal from "./ParticipantsModal";
import EquipmentModal from "./EquipmentModal";
import { getTrainingsList, trainingDetails, deleteTraining, getTrainingListSummary } from "../../../../services/adminApiService/batchManagementApi/BatchManagementApiService";
import { useDeleteHandler } from "../../../../hooks/useDeleteHandler";
import PageTitle from "../../../../jsx/layouts/PageTitle";
import AthletesModal from './AthletesModal';
import AttendanceModal from "./AttendanceModal";
import AttendanceDetailModal from "../Attendance/AttendanceDetailModal";
import TrainingAthletesModal from "./TrainingAthletesModal";

const Index = () => {
  const [selectedTraining, setSelectedTraining] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  // const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showParticipantsModal, setShowParticipantsModal] = useState(false);
  const [showAthletesModal, setShowAthletesModal] = useState(false);
  const [showEquipmentModal, setShowEquipmentModal] = useState(false);
  const [showAttendanceModal, setShowAttendanceModal] = useState(false);
  const [showAttendanceDetailModal, setShowAttendanceDetailModal] = useState(false);
  const [events, setEvents] = useState([]);

  const [eventDetails, setEventDetails] = useState([]);
  const [eventLoading, setEventLoading] = useState(false);
  const { handleDelete } = useDeleteHandler();

  const calendarRef = useRef(null);
  const [activeView, setActiveView] = useState("dayGridMonth");
  const [searchValue, setSearchValue] = useState("");

  // List view state
  const [listView, setListView] = useState(false);
  const [listData, setListData] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const [listPage, setListPage] = useState(1);
  const [listTotalPages, setListTotalPages] = useState(1);
  const [listSearch, setListSearch] = useState("");
  const [showTrainingAthletesModal, setShowTrainingAthletesModal] = useState(false);
  const [listSelectedRecord, setListSelectedRecord] = useState(null);

  const addOneDay = (date) => {
    const d = new Date(date);
    d.setDate(d.getDate() + 1);
    return d.toISOString().split("T")[0];
  };

  // const navigate = useNavigate();

  useEffect(() => {
    fetchEvents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  useEffect(() => {
    if (listView) {
      fetchListData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listView, listPage]);

  const fetchEvents = async () => {
    try {

      const payload = {
        search: searchValue
      };

      const response = await getTrainingsList(payload);

      const apiData = response?.data?.data || [];

      const formattedEvents = apiData?.map(item => {
        if (item.is_all_day === 1) {
          return {
            id: item.id,
            title: item.training_name,
            start: item.training_date,
            end: addOneDay(item.training_end_date),
            allDay: true,
            extendedProps: item
          };
        } else {
          return {
            id: item.id,
            title: item.training_name,
            start: `${item.training_date}T${item.start_time}`,
            end: `${item.training_end_date}T${item.end_time}`,
            allDay: false,
            extendedProps: item
          };
        }
      });

      setEvents(formattedEvents);

    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const fetchListData = async () => {
    try {
      setListLoading(true);
      const res = await getTrainingListSummary({ page: listPage, per_page: 10, search: listSearch });
      const payload = res?.data?.data;
      setListData(payload?.data || []);
      setListTotalPages(payload?.last_page || 1);
    } catch (err) {
      console.error("Error fetching list data:", err);
      setListData([]);
    } finally {
      setListLoading(false);
    }
  };

  const handleListSearch = () => {
    setListPage(1);
    fetchListData();
  };

  const handleEventClick = (info) => {
    const eventData = info.event.extendedProps;
    setSelectedTraining(eventData);
    setShowViewModal(true);
  };

  useEffect(() => {
    if (selectedTraining) {
      fetchEvenetDetails(selectedTraining?.id)
    }

  }, [selectedTraining]);

  const fetchEvenetDetails = async (trainingId) => {
    try {
      setEventLoading(true);
      const response = await trainingDetails(trainingId);
      setEventDetails(response?.data?.data || {});

    } catch (error) {
      console.error("Error fetching event details:", error);
    }
    finally {
      setEventLoading(false);
    }
  };


  const deleteHandler = (id) => {
    handleDelete({
      deleteApi: () => deleteTraining(id),
      refreshListApi: () =>
        fetchEvents(), // Call the refreshList function passed as a prop
      successMsg: "Training deleted successfully"
    });
  };

  const changeView = (view) => {
    const calendarApi = calendarRef.current?.getApi();
    calendarApi.changeView(view);
    setActiveView(view);
  };



  return (
    <>
      <PageTitle activeMenu="Calendar" motherMenu="Manage Calendar " />

      <div className="calendar-wrapper card p-4">

        {/* Custom Header */}
        <div className="calendar-topbar">

          {!listView ? (
            <input
              type="text"
              placeholder="Search training name ..."
              className="calendar-search"
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
              }}
            />
          ) : (
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <input
                type="text"
                placeholder="Search training name ..."
                className="calendar-search"
                style={{ marginBottom: 0 }}
                value={listSearch}
                onChange={(e) => setListSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleListSearch()}
              />
              <button
                onClick={handleListSearch}
                style={{
                  padding: "6px 14px",
                  background: "#8757e8",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "13px",
                  whiteSpace: "nowrap"
                }}
              >
                Search
              </button>
            </div>
          )}

          {!listView && (
            <div className="calendar-view-btns">
              <button
                className={activeView === "timeGridDay" ? "active" : ""}
                onClick={() => changeView("timeGridDay")}
              >
                Day
              </button>

              <button
                className={activeView === "timeGridWeek" ? "active" : ""}
                onClick={() => changeView("timeGridWeek")}
              >
                Week
              </button>

              <button
                className={activeView === "dayGridMonth" ? "active" : ""}
                onClick={() => changeView("dayGridMonth")}
              >
                Month
              </button>
            </div>
          )}

          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            <div className="calendar-view-btns">
              <button
                className={!listView ? "active" : ""}
                onClick={() => setListView(false)}
              >
                Calendar
              </button>
              <button
                className={listView ? "active" : ""}
                onClick={() => {
                  setListView(true);
                  setListPage(1);
                }}
              >
                List
              </button>
            </div>

            <Link to="/batch-management/calendar/create-training">
              <button variant="primary" className="create-btn">
                + Create
              </button>
            </Link>
          </div>

        </div>

        {/* Calendar View */}
        {!listView && (
          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            events={events}
            eventClick={handleEventClick}
            height="100vh"
            displayEventTime={false}
            eventColor="#8757e8"
          />
        )}

        {/* List View */}
        {listView && (
          <div style={{ marginTop: "16px" }}>
            <div style={{ overflowX: "auto" }}>
              <table className="table mb-0" style={{ borderRadius: "10px", overflow: "hidden" }}>
                <thead>
                  <tr style={{ background: "#8757e8" }}>
                    <th className="text-white fw-semibold py-2 px-3">Training Name</th>
                    <th className="text-white fw-semibold py-2 px-3 d-none d-md-table-cell">Sport</th>
                    <th className="text-white fw-semibold py-2 px-3">Session Date</th>
                    <th className="text-white fw-semibold py-2 px-3 d-none d-md-table-cell">Venue</th>
                    <th className="text-white fw-semibold py-2 px-3 d-none d-md-table-cell">Instructor</th>
                    <th className="text-white fw-semibold py-2 px-3">Athletes</th>
                    <th className="text-white fw-semibold py-2 px-3 d-none d-md-table-cell">Cluster</th>
                    <th className="text-white fw-semibold py-2 px-3">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {listLoading ? (
                    <tr>
                      <td colSpan={8} className="text-center py-4">Loading...</td>
                    </tr>
                  ) : listData.length === 0 ? (
                    <tr>
                      <td colSpan={8} className="text-center py-4">No training sessions found</td>
                    </tr>
                  ) : (
                    listData.map((row, idx) => (
                      <tr key={`${row.id}-${idx}`} style={{ borderBottom: "1px solid #f0f0f0" }}>
                        <td className="py-2 px-3 fw-semibold" style={{ maxWidth: "150px", wordBreak: "break-word" }}>
                          {row.training_name || "—"}
                          <div className="d-md-none text-muted" style={{ fontSize: "11px", fontWeight: 400 }}>
                            {[row.sport_name, row.venue_name, row.cluster_name].filter(Boolean).join(" · ")}
                          </div>
                        </td>
                        <td className="py-2 px-3 d-none d-md-table-cell">{row.sport_name || "—"}</td>
                        <td className="py-2 px-3">{row.training_date || "—"}</td>
                        <td className="py-2 px-3 d-none d-md-table-cell">{row.venue_name || "—"}</td>
                        <td className="py-2 px-3 d-none d-md-table-cell">{row.instructor_names || "—"}</td>
                        <td className="py-2 px-3" style={{ textAlign: "center" }}>{row.total_athletes ?? 0}</td>
                        <td className="py-2 px-3 d-none d-md-table-cell">{row.cluster_name || "—"}</td>
                        <td className="py-2 px-3">
                          <button
                            className="btn btn-sm"
                            onClick={() => {
                              setListSelectedRecord(row);
                              setShowTrainingAthletesModal(true);
                            }}
                            style={{ background: "#8757e8", color: "#fff", borderRadius: "8px", padding: "6px 10px" }}
                            title="View Athletes"
                          >
                            <FaEye size={15} />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {listTotalPages > 1 && (
              <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: "16px" }}>
                <button
                  onClick={() => setListPage((p) => Math.max(1, p - 1))}
                  disabled={listPage === 1}
                  style={{
                    padding: "6px 14px",
                    background: listPage === 1 ? "#e0e0e0" : "#8757e8",
                    color: listPage === 1 ? "#999" : "#fff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: listPage === 1 ? "not-allowed" : "pointer"
                  }}
                >
                  Previous
                </button>
                <span style={{ lineHeight: "32px", fontSize: "13px" }}>
                  Page {listPage} of {listTotalPages}
                </span>
                <button
                  onClick={() => setListPage((p) => Math.min(listTotalPages, p + 1))}
                  disabled={listPage === listTotalPages}
                  style={{
                    padding: "6px 14px",
                    background: listPage === listTotalPages ? "#e0e0e0" : "#8757e8",
                    color: listPage === listTotalPages ? "#999" : "#fff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: listPage === listTotalPages ? "not-allowed" : "pointer"
                  }}
                >
                  Next
                </button>
              </div>
            )}
          </div>
        )}

        {showViewModal && (
          <ViewTrainingModal
            data={eventDetails}
            onClose={() => setShowViewModal(false)}
            onDelete={() => {
              setShowViewModal(false);
              deleteHandler(selectedTraining?.id);
            }}
            onParticipants={() => {
              setShowViewModal(false);
              setShowParticipantsModal(true);
            }}
            onAthletes={() => {
              setShowViewModal(false);
              setShowAthletesModal(true);
            }}
            onEquipment={() => {
              setShowViewModal(false);
              setShowEquipmentModal(true);
            }}
            onAttendance={() => {
              setShowViewModal(false);
              setShowAttendanceModal(true);
            }}
            onViewAttendance={() => {
              setShowViewModal(false);
              setShowAttendanceDetailModal(true);
            }}
            loading={eventLoading}
          />
        )}

        {/* {showDeleteModal && (
        <DeleteTrainingModal
          onClose={() => setShowDeleteModal(false)}
        />
      )} */}

        {showParticipantsModal && (
          <ParticipantsModal
            data={eventDetails}
            onClose={() => setShowParticipantsModal(false)}
          />
        )}

        {showAthletesModal && (
          <AthletesModal
            data={eventDetails}
            onClose={() => setShowAthletesModal(false)}
          />
        )}

        {showEquipmentModal && (
          <EquipmentModal
            data={eventDetails}
            onClose={() => setShowEquipmentModal(false)}
          />
        )}

        <AttendanceModal
          show={showAttendanceModal}
          onHide={() => setShowAttendanceModal(false)}
          training={eventDetails}
        />

        {/* Detail modal from calendar event click (View Attendance button) */}
        <AttendanceDetailModal
          show={showAttendanceDetailModal}
          onHide={() => setShowAttendanceDetailModal(false)}
          trainingId={eventDetails?.id}
          trainingName={eventDetails?.training_name}
        />

        {/* Athletes modal from list view eye button */}
        <TrainingAthletesModal
          show={showTrainingAthletesModal}
          onHide={() => setShowTrainingAthletesModal(false)}
          trainingId={listSelectedRecord?.id}
          trainingName={listSelectedRecord?.training_name}
        />
      </div>
    </>
  );
};

export default Index;
